import { z } from 'zod';

import { UploadState } from './upload-status';

export type UploadsQuery = z.infer<typeof uploadsQuerySchema>;

export const uploadsQuerySchema = z.object({
  state: z.enum(UploadState),
});
